/* eslint-disable semi */

const API_URL = 'https://api.treetalk.co.uk';
const TreeTalkAPI = API_URL;

// Used e.g. to access geocoding search in AddressSearchField
const mapboxAccessTokenAddressLookup = 'pk.eyJ1IjoicmV2b2x1dGlvbmNvbnN1bHRhbmN5IiwiYSI6ImNrOGowcnY3cDAxdTkza25hcDB4NXJkYnoifQ._Q0LYAuH9JVIBBgwLP1iXQ';

const centreLat = 51.507973;
const centreLon = -0.127980; // trafalgar square LAT LON

export default {

  // *****************************************************************
  ROUTES_PROJECT: 'treetalk_prod',
  // *****************************************************************

  getURI (urlparams, queryparams) {
    let sessionGUID = '000000000000000000000000000'; // TODO: use correct logic
    if (!queryparams) {
      return TreeTalkAPI + urlparams + '?s=' + sessionGUID;
    } else {
      return TreeTalkAPI + urlparams + '?' + queryparams + '&s=' + sessionGUID;
    }
  },

  // Location lookup
  mapboxAccessTokenAddressLookup: mapboxAccessTokenAddressLookup,

  // Used to limit lookup range
  centre: [centreLat, centreLon], // trafalgar square LAT LON (not same as used in geojson which is LON LAT!!!!!)
  centreLonLat: [centreLon, centreLat],

  // Bounding boxes should be supplied as four numbers separated by commas, in minLon,minLat,maxLon,maxLat order
  // long lat long lat used mapbox location search in AddressSearchField
  boundingBoxLonLat: [
      -0.564347, 51.319549, // Woking
      0.243595, 51.708542, // Chipping Ongar
  ],

  treeTalkWebsite: 'https://www.treetalk.co.uk'

}
